// extracted by mini-css-extract-plugin
export default {"topDiv":"Collections_topDiv__FT0zP","bottomDiv":"Collections_bottomDiv__5MuIF","topAndBottomDivContainer":"Collections_topAndBottomDivContainer__+ZECq"};